import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { vi } from 'date-fns/locale'; // Import locale tiếng Việt
import { format, isValid, parseISO } from 'date-fns';

const customVi = { ...vi };

customVi.localize = {
    ...vi.localize,
    month: (index) => {
        // index chạy từ 0 (Tháng 1) đến 11 (Tháng 12)
        return `Tháng ${index + 1},`;
    }
};

/**
 * CustomDatePicker sử dụng MUI X DatePicker
 * Giữ nguyên interface props cũ để tương thích với code hiện tại
 */
const CustomDatePicker = ({ value, onChange, name, label, disabled, required, sx, ...props }) => {

    // 1. Chuyển đổi chuỗi 'YYYY-MM-DD' sang Date Object để MUI hiểu
    const dateValue = value ? parseISO(value) : null;

    // 2. Xử lý khi chọn ngày -> Chuyển lại thành chuỗi 'YYYY-MM-DD' hoặc ''
    const handleDateChange = (newValue) => {
        let formattedDate = '';
        if (newValue && isValid(newValue)) {
            formattedDate = format(newValue, 'yyyy-MM-dd');
        }

        // Giả lập event object để tương thích với logic handleChange cũ
        if (onChange) {
            onChange({
                target: {
                    name: name,
                    value: formattedDate
                }
            });
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customVi}>
            <DatePicker
                label={label}
                value={dateValue}
                onChange={handleDateChange}
                format="dd/MM/yyyy" // ĐỊNH DẠNG HIỂN THỊ MONG MUỐN
                disabled={disabled}
                dayOfWeekFormatter={(date) => {
                    const day = date.getDay(); // 0 (Chủ nhật) -> 6 (Thứ 7)
                    const dayNames = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
                    return dayNames[day];
                }}
                slotProps={{
                    textField: {
                        size: "small",
                        fullWidth: true,
                        required: required,
                        sx: { 
                            ...sx,
                            backgroundColor: disabled ? '#f8f6f6ff' : '#fff',
                            '& .MuiInputBase-input': {
                                cursor: disabled ? 'default' : 'pointer', // Sửa con trỏ chuột
                            }
                        },
                        ...props
                    },
                    openPickerIcon: { fontSize: 'small' },
                    layout: {
                        sx: {
                            // Ẩn bớt padding thừa của khung View
                            '.MuiPickersDateCalendar-root': {
                                height: 'auto',
                                width: 'auto',
                                margin: 0
                            }
                        }
                    }
                }}
            />
        </LocalizationProvider>
    );
};

export default CustomDatePicker;